import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { canUseDOM } from 'exenv';
import Link from 'react-router-dom/Link';
import Social from '../social/social';
import PersonCompanyBio from '../person_company_bio/person_company_bio';
import { sortAwards } from '../../../utils/sorter';

export default class PersonCompanyComponent extends Component {
  constructor() {
    super();

    this.state = { expandedBio: true };
    this.renderPortrait = this.renderPortrait.bind(this);
    this.scopedToggleExpandedBio = this.toggleExpandedBio.bind(this);
    this.scopedInitialHeight = this.getInitialHeight.bind(this);
  }

  getInitialHeight() {
    if (canUseDOM) {
      const mainSection = document.querySelector(
        '.person-company-component__main'
      );
      if (mainSection.clientHeight < 300 || window.innerWidth < 640) {
        this.setState({ expandedBio: true });
      }
    }
  }

  toggleExpandedBio() {
    this.setState({ expandedBio: true });
  }

  socialMediaLink(name, value) {
    if (name === 'Website') {
      return value;
    } else if (name === 'LinkedIn') {
      return `https://www.linkedin.com/${value}`;
    }
    return `https://${name}.com/${value}`;
  }

  socialMediaLabel(name, value) {
    if (name === 'Website') {
      return value;
    }
    return name;
  }

  renderPersonOrCompanyEyebrow(context, mcp, ibd, type) {
    if (!mcp && !ibd) {
      if (type === 'person') {
        return (
          <div>
            <Link to="/person">
              <span className="person-company-component__mcp-credit-year">
                Person&nbsp;
              </span>
            </Link>
            <span className="person-company-component__mcp-credit-year">
              | Profile
            </span>
          </div>
        );
      } else if (type === 'company') {
        return (
          <div>
            <Link to="/company">
              <span className="person-company-component__mcp-credit-year">
                Company&nbsp;
              </span>
            </Link>
            <span className="person-company-component__mcp-credit-year">
              | Profile
            </span>
          </div>
        );
      }
      return null;
    }

    if (type === 'person' && mcp) {
      if (!get(context, 'year')) {
        return (
          <Link to="/most-creative-people-community">
            <span className="person-company-component__mcp-credit-year">
              {'Most Creative People'}
            </span>
          </Link>
        );
      }

      return (
        <Link to={`/most-creative-people/${get(context, 'year', '')}`}>
          <span className="person-company-component__mcp-credit-year">{`Most Creative People ${get(
            context,
            'year',
            ''
          )}`}</span>
        </Link>
      );
    }

    if (type === 'company' && ibd) {
      return (
        <Link to="/most-innovative-companies">
          <span className="person-company-component__mcp-credit-year">
            {'Most Innovative Companies'}
          </span>
        </Link>
      );
    }

    return null;
  }

  renderPortrait(personOrCompany) {
    if (personOrCompany && this.hasPortrait) {
      const $image = get(personOrCompany, 'images[0]');
      let credit = '';

      if (get($image, 'credit.length')) {
        credit = (
          <span
            className="person-company-component__poster-credit"
            dangerouslySetInnerHTML={{ __html: $image.credit }}
          />
        );
      }

      return (
        <div className="person-company-component__poster">
          <img
            className="person-company-component__poster-image"
            src={$image.url}
            alt={this.fullName}
          />
          {credit}
        </div>
      );
    }

    return null;
  }

  renderTitle(personOrCompany) {
    if (personOrCompany) {
      const title = [];
      if (personOrCompany.job_title) {
        title.push(<span key="job_title">{personOrCompany.job_title}</span>);
      }

      if (
        get(personOrCompany, 'companies[0].name') &&
        get(personOrCompany, 'companies[0].url')
      ) {
        title.push(
          <span key="company">
            ,{' '}
            <a
              href={`//www.fastcompany.com/company/${
                personOrCompany.companies[0].url
              }`}
            >
              {personOrCompany.companies[0].name}
            </a>
          </span>
        );
      }

      if (get(personOrCompany, 'location')) {
        title.push(
          <span key="location"> | {get(personOrCompany, 'location')}</span>
        );
      }

      return title;
    }

    return null;
  }

  renderReason(personOrCompany) {
    const why = get(personOrCompany, 'mcp100[0].why');

    if (personOrCompany && why) {
      return <div className="person-company-component__mcp-reason">{why}</div>;
    }

    return null;
  }

  renderAwards(awards) {
    if (!awards.length) return null;

    return (
      <div className="person-company-component__information">
        <span className="person-company-component__information-title">
          Lists
        </span>
        {awards.map(
          year =>
            year.year !== '2021' ? (
              <div
                key={`${year.year}`}
                className="person-company-component__information-item"
              >
                {year.year}:{' '}
                {year.awards.map((award, idx) => (
                  <span key={`${year.year}${award.sector_name}`}>
                    {award.sector_url === year.year ? (
                      <a
                        href={`https://www.fastcompany.com/most-innovative-companies/${
                          year.year
                        }`}
                      >
                        {idx + 1 !== year.awards.length ? (
                          <span>{award.sector_name}, </span>
                        ) : (
                          <span>{award.sector_name}</span>
                        )}
                      </a>
                    ) : (
                      <a
                        href={
                          year.year === '2020'
                            ? award.sector_url
                            : `https://www.fastcompany.com/most-innovative-companies/${
                                year.year
                              }/sectors/${award.sector_url}`
                        }
                      >
                        {idx + 1 !== year.awards.length ? (
                          <span>{award.sector_name}, </span>
                        ) : (
                          <span>{award.sector_name}</span>
                        )}
                      </a>
                    )}
                  </span>
                ))}
              </div>
            ) : null
        )}
      </div>
    );
  }

  renderData(personOrCompany) {
    const data = get(personOrCompany, 'data') || [];
    const competitors = get(personOrCompany, 'competitors') || [];

    if (!data.length) return null;

    return (
      <div className="person-company-component__information">
        <span className="person-company-component__information-title">
          Data
        </span>
        {data.map(item => (
          <div
            key={item.name}
            className="person-company-component__information-item"
          >
            <span className="person-company-component__data-name">
              {item.name}:{' '}
            </span>
            <span className="person-company-component__data-value">
              {item.value}
            </span>
          </div>
        ))}
        {competitors.length ? (
          <div className="person-company-component__information-item">
            <span className="person-company-component__data-name">
              {'Competition: '}
              {competitors.map((item, idx) => (
                <Link key={item.url} to={`/company/${item.url}`}>
                  {idx + 1 !== competitors.length ? (
                    <span>{item.name}, </span>
                  ) : (
                    <span>{item.name}</span>
                  )}
                </Link>
              ))}
            </span>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }

  renderSocialMedia(personOrCompany) {
    const socialMedia = get(personOrCompany, 'social_media') || [];

    if (!socialMedia.length) return null;

    return (
      <div className="person-company-component__information">
        <span className="person-company-component__information-title">
          {this.fullName} On The Web
        </span>
        {socialMedia.map(item => (
          <div
            key={item.name}
            className="person-company-component__information-item"
          >
            <a href={this.socialMediaLink(item.name, item.value)}>
              {this.socialMediaLabel(item.name, item.value)}
            </a>
          </div>
        ))}
      </div>
    );
  }

  render() {
    if (!this.props) {
      return null;
    }

    const { personOrCompany, awards, type } = this.props;

    const isPersonOrCompany = get(personOrCompany, 'name')
      ? 'company'
      : 'person';

    this.fullName = get(personOrCompany, 'name')
      ? personOrCompany.name
      : `${get(personOrCompany, 'first_name')} ${get(
          personOrCompany,
          'last_name'
        )}`;
    this.hasPortrait = !!get(personOrCompany, 'images[0].url');
    const mcpAwards = get(personOrCompany, 'mcp_awards');
    const mcpYear = get(personOrCompany, 'mcp_awards[0].year');
    const encodedUrl = encodeURIComponent(
      `https://www.fastcompany.com/${isPersonOrCompany}/${get(
        personOrCompany,
        'url'
      )}`
    );
    const shareCopy = {
      personOrCompany: `${
        this.fullName
      }: Latest News, Work, Videos, Photos on Fast Company`,
      mcp: `Meet ${
        this.fullName
      }, one of @FastCompany's 100 Most Creative People in Business #FCMostCreative`,
      mcpAwards: `Meet ${
        this.fullName
      }, one of @FastCompany's 100 Most Creative People in Business ${mcpYear} #FCMostCreative`,
      ibd: `Check out ${
        this.fullName
      }, one of @FastCompany's Most Innovative Businesses #FCMostInnovative`,
      default: `Read more about ${this.fullName} on @FastCompany`
    };
    const isMCP = get(personOrCompany, 'mcp') === 1;
    const isIBD = Boolean(get(awards, 'length', 0));
    let value;

    if (isMCP && !get(mcpAwards, 'length')) {
      value = 'mcp';
    } else if (isMCP && get(mcpAwards, 'length')) {
      value = 'mcpAwards';
    } else if (isIBD) {
      value = 'ibd';
    } else {
      value = 'default';
    }

    const encodedText = encodeURIComponent(shareCopy[value]);
    const sortedAwards = sortAwards(awards);

    return (
      <section
        className={`person-company-component person-company-component--${
          this.fullName
        }`}
      >
        <Social
          enableSticky={false}
          text={encodedText}
          uri={encodedUrl}
          modifier="person-page"
          topValue={0}
        />
        {this.renderPortrait(personOrCompany)}
        <div
          ref={this.scopedInitialHeight}
          className={`person-company-component__main${
            this.state.expandedBio
              ? ' person-company-component__main--expanded'
              : ''
          } ${
            this.hasPortrait || isIBD
              ? ''
              : 'person-company-component__main--no-portrait'
          }`}
        >
          {this.renderPersonOrCompanyEyebrow(
            get(personOrCompany, 'mcp_awards[0]'),
            get(personOrCompany, 'mcp'),
            get(awards, 'length'),
            type
          )}
          <h1 className="person-company-component__name">{this.fullName}</h1>
          <h2 className="person-company-component__title">
            {this.renderTitle(personOrCompany)}
          </h2>
          {this.renderReason(personOrCompany)}
          <PersonCompanyBio
            personOrCompany={personOrCompany}
            awards={sortedAwards}
            isIBD={isIBD}
          />
          {this.renderAwards(sortedAwards)}
          {this.renderData(personOrCompany)}
          {this.renderSocialMedia(personOrCompany)}
        </div>
      </section>
    );
  }
}

PersonCompanyComponent.defaultProps = {
  awards: []
};

PersonCompanyComponent.propTypes = {
  personOrCompany: PropTypes.shape({}).isRequired,
  type: PropTypes.string.isRequired,
  awards: PropTypes.arrayOf(PropTypes.shape({}))
};
